import { START_LOADING, STOP_LOADING } from './actionTypes';

const startLoadingAction = () => (dispatch) => dispatch({ type: START_LOADING });

const stopLoadingAction = () => (dispatch) => dispatch({ type: STOP_LOADING });

export { startLoadingAction, stopLoadingAction };
